import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { SignoPlanService } from '@services/entidades/signo-planes.service';
import { SignoAuditoriaService } from '@services/auditoria/signo-auditoria.service';
import { SignoPlan } from '@interfaces/interface-bakend/entidades/signo-plan.interface';
import { Router } from '@angular/router';
import { GuiMsjService } from 'src/app/services/shared/gui-msj.service';
import { MediaService } from 'src/app/services/shared/media.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-plan-alta',
  templateUrl: './plan-alta.component.html',
  styleUrls: ['./plan-alta.component.scss']
})
export class PlanAltaComponent implements OnInit, OnDestroy {
  form: FormGroup;

  // Upload
  flagSelectFile = false;
  selectedFile: any;
  value = 0;
  cargandoArchivo = false;
  subscriptionAvance: Subscription;
  fileName = 'No file selected';
  file: File;

  constructor(
    private signoPlanService: SignoPlanService,
    private mediaService: MediaService,
    private route: Router,
    private guiMsjService: GuiMsjService,
    private signoAuditoriaService: SignoAuditoriaService,
  ) {
    this.createForm();
  }

  ngOnInit(): void {
    this.subscribeAvanceUpload();
    this.signoAuditoriaService.registrarEvento({
      accion: 'PANTALLA_ACCESO',
      modulo: 'Planes',
      pantalla: 'PlanAlta',
      ruta: '/plan-alta',
      resultado: 'EXITO',
    });
  }

  ngOnDestroy(): void {
    if (this.subscriptionAvance) {
      this.subscriptionAvance.unsubscribe();
    }
  }

  get idRefNoValido() {
    return this.form.get('identificacion').invalid;
  }

  get planNoValido() {
    return this.form.get('denominacion').invalid;
  }

  createForm() {
    this.form = new FormGroup({
      identificacion: new FormControl('', [
        Validators.required,
        Validators.maxLength(50)
      ]),
      denominacion: new FormControl('', [
        Validators.required,
        Validators.minLength(2),
        Validators.maxLength(50),
      ]),
      pdf: new FormControl(''),
      activoDescarga: new FormControl(false),
      leyendaUsuario: new FormControl(''),
    });
  }

  async createPlan() {
    await this.guiMsjService.msjFormSubmit('Guardando');
    this.signoPlanService.create(await this.setDataForma()).then(async (plan: SignoPlan) => {
      let uploadExitoso = true;
      if (this.selectedFile && plan && plan._id) {
        uploadExitoso = await this.uploadFile(this.selectedFile, plan._id);
      }
      const pdfSubido = !!this.selectedFile;
      this.signoAuditoriaService.registrarEvento({
        accion: pdfSubido ? 'CREAR_CON_PDF' : 'CREAR_SIN_PDF',
        recurso: 'Plan',
        modulo: 'Planes',
        pantalla: 'PlanAlta',
        ruta: '/plan-alta',
        payload: {
          planId: plan._id,
          idRef: plan.idRef,
          denominacion: plan.denominacion,
          pdfSubido,
          pdfFilename: this.selectedFile?.name || null,
        },
        resultado: uploadExitoso ? 'EXITO' : 'ERROR',
      });
      await this.guiMsjService.msjFormSubmit('DatosGuardados');
      this.route.navigateByUrl('/planes-listado');
    });
  }

  async setDataForma(): Promise<SignoPlan> {
    const plan: SignoPlan = {
      idRef: this.form.value.identificacion,
      denominacion: this.form.value.denominacion || "",
      activoDescarga: this.form.value.activoDescarga || false,
      leyendaUsuario: this.form.value.leyendaUsuario || "",
    };

    return plan;
  }

  /* UPLOAD */
  subscribeAvanceUpload() {
    this.subscriptionAvance = this.mediaService.getAvance().subscribe(resp => {
      if (resp) {
        this.value = resp.value;
      } else {
        this.value = 0;
      }
    });
  }

  openFileSelected(event) {
    this.selectedFile = <File>event.target.files[0];
  }

  onChangeFile(file: File, event) {
    if (file) {
      this.openFileSelected(event);
      this.fileName = file.name;
      this.file = file;
    }
  }

  async uploadFile(selectedFile, idplan): Promise<boolean> {
    this.cargandoArchivo = true;
    return this.mediaService.uploadPdfPlan(selectedFile, idplan).then(resp => {
      if (resp) {
        if (this.value === 100) { this.cargandoArchivo = false; }
        return true;
      } else {
        this.guiMsjService.msjFormSubmit('uploadDocumentERROR');
        return false;
      }
    });
  }
}
